import { environment } from '@environments/environment';
import { Application } from '@enums/application.enums';
import { TableHeaderTypes } from '@enums/table.enum';

export { fieldTypes } from './dynamic-form-fieldtypes';

export const StoreShareConstants = {
  IMAGE_WIDTH: 180,
  IMAGE_HEIGHT: 180,
  BORDER_RADIUS: 16,
  IMAGE_MAX_WIDTH: 250
};

export const Fields = {
  GAMIFICATION: 'Gamification',
  BADGES: 'Badges',
  LOYALTY_POINTS: 'Loyalty Points',
  RESPONSE: 'Response',
  ADDRESS_INPUT_CHANGE: 'ADDRESS_INPUT_CHANGE',
  ADDRESS_INPUT_SELECTED: 'ADDRESS_INPUT_SELECTED',
  readArticle: 'Read Article',
  UNFOLLOW: 'Unfollow',
  DISABLE_NFT: 'Disable NFT',
  ENABLE_NFT: 'Enable NFT',
  ADDED: 'Added',
  SUBSCRIBERS_ONLY: 'Subscribers Only',
  SUBSCRIPTION_MESSAGE:
    "To participate in [username]'s Chat Room you need to become a subscriber",
  WITHDRAWN: 'Withdrawn',
  COLLAB_ACTION_IGNORE: 'collab-action-ignore',
  IGNORE_COLLAB: 'Ignore Collab',
  ALERT: 'alert',
  UPDATE_WHITELABEL_SITE: 'update-whitelabel-site',
  CANCEL_SUBSCRIPTION: 'cancel-subscription',
  REACTIVATE_ACCOUNT: 'Reactivate account',
  UNBLOCK: 'Unblock',
  WHITE_LABEL: 'white-label',
  REMOVE_WHITELABEL_SITE: 'Remove White-Label Site',
  UPDATE_WHITELABEL_SITE_SETTINGS: 'Update White-Label Site Settings',
  YOUR_ACCOUNT_HAS_BEEN_SUSPENDED: 'Your account has been suspended',
  NO_ACCESS_TO_CONTENT: 'you do not have permission to access this content.',
  DELETE: 'Delete',
  FORUM_POST: 'forum-post',
  COMMENT: 'comment',
  REPLY: 'reply',
  FORUM_COMMENT: 'forum-comment',
  FORUM_REPLY: 'forum-reply',
  DELETE_COMMENT: 'Delete Comment',
  DELETE_COURSE: 'Delete Course',
  DELETE_LESSON: 'Delete Lesson',
  DELETED: 'Deleted',
  SUSPENDED: 'Suspended',
  SUSPEND: 'Suspend',
  DELETE_POST: 'Delete Post',
  DELETE_DISCUSSION: 'Delete Discussion',
  DELETE_EXPERIENCE: 'Delete Experience',
  DELETE_SEGMENT: 'Delete Segment',
  SEGMENT: 'segment',
  ACCOUNT_PAUSED: 'Account Paused',
  ACCOUNT_DELETED: 'Account Deleted',
  EXPERIENCE: 'experience',
  COURSE: 'course',
  LESSON: 'lesson',
  POST: 'post',
  BACK: 'Back',
  NO: 'No',
  YES: 'Yes',
  CANCEL: 'Cancel',
  REMOVE: 'Remove',
  SETUP_W_9: 'Add Bank Details',
  CONFIRM_CANCELLATION: 'Confirm Cancellation',
  DISABLE_MERCHANDISE: 'Disable Merchandise',
  ENABLE_MERCHANDISE: 'Enable Merchandise',
  openURL: 'OPEN LINK',
  Meta: 'Meta',
  collab: 'Collab',
  SAVE_SEGMENT: 'Save Segment',
  locked: 'Locked',
  OK: 'OK',
  THANKS_FOR_SUPPORTING: 'Thanks for supporting',
  TIP_RECEIVED: 'Your Tip has been received.',
  unlockToSeePost: 'Unlock to See Post',
  subscribeToSeePost: 'Subscribe to See Post',
  subscribeToListen: 'Subscribe to Listen',
  or: 'or',
  pay: 'Pay $',
  payText: 'Pay',
  toView: ' to View',
  toListen: ' to Listen',
  REJECTED: 'REJECTED',
  REQUESTED: 'Requested',
  requested: 'requested',
  follow: 'follow',
  unfollow: 'unfollow',
  RemoveCollaboration: 'Remove Collaboration',
  unlockWithNFT: 'Unlock With NFT',
  guaranteedReply: 'guaranteedReply',
  tip: 'tip',
  payPerMessage: 'payPerMessage',
  payPerMessageAndTip: 'payPerMessageAndTip',
  text: 'text',
  feedPreviewImage: 'Feed Preview Image',
  optionalEventImage: 'Optional Event Image',
  imageInfo:
    'Width of image should be greater than 450 pixels and height of image should be greater than 200 pixels.',
  eventImageInfo:
    'This image is optional and will show in Link In Bio and under the Date on your Events listing page. Recommended Size 400 (h) x 400 (w).',
  upload: 'Upload',
  cancel: 'Cancel',
  pixels: 'pixels',
  chooseFile: 'CHOOSE A FILE',
  LIKES: 'Likes',
  Comments: 'Comments',
  Comment: 'Comment',
  LIKE: 'Like',
  downloadSampleCsv: 'DOWNLOAD SAMPLE CSV',
  allType: 'ALL',
  CLOSE: 'Close',
  CREATOR_TYPE: 'CREATOR TYPE',
  ACCOUNT_SUSPENDED: 'Account Suspended',
  ADD: 'add',
  ADDED_TO: 'added to',
  USER_IS_NOT_ACTIVE: 'User is not active or verified.',
  WITHDRAWN_FROM: 'withdrawn from',
  Money_Message: '[amount] has been successfully [action] your wallet.',
  SUSPENSION_NOTE:
    'Note: You will need to login after your suspension ends for your account to be reactivated.',
  CUSTOMER_SUPPORT:
    'If you think this is a mistake, please contact our customer support team.',
  downloadableType: 'downloadable',
  downloadableTypeLabel: 'Downloadable',
  downloadablesType: 'downloadables',
  downloadEnable: 'Downloadable will [enable] be visible to fans.',
  submitAnswer: 'Submit Answer',
  viewResponse: 'View [response] Responses',
  submittedAnswers: 'Submitted Answers',
  giveawayEntries: 'Giveaway Entries -',
  downloadCsv: 'DOWNLOAD CSV',
  customExperienceInstructionsLabel: 'Optional: Custom Experience Instructions',
  customExperienceInstructionsPlaceholder: 'If applicable, ask the fan to provide you the details needed to fulfill the custom experience.',
  customExperienceInstructionsMaxLengthError: 'Maximum 1000 characters allowed.',
  customExperienceInstructionsInvalidError: 'Invalid Custom Experience Instructions',
  question: 'Question',
  Following: 'Following',
  FOLLOW: 'Follow',
  Hashtag: 'HASHTAG#',
  imagesPreview: 'Preview',
  legalFirstName: 'Legal First Name',
  restrictDownlodableLabel: 'Restrict Ability to Access Downloadables',
  ScreenshotPreventionHeading: 'Taking Screenshots is Not Allowed On TopFan',
  ScreenshotPreventionHeadingWhiteLabel: 'Taking Screenshots is Not Allowed',
  ScreenshotPreventionDescription:
    'Please do not take screenshots or leak content without permission.<br> To protect our creators, content leaks are reported to law enforcement.',
  ScreenshotButtonLabel: 'OK',
  enable: 'Enable',
  disable: 'Disable',
  deleteDownloadable: 'Delete Downloadables',
  PAY: 'Pay',
  Guaranteed_Reply_Fulfilled: 'Guaranteed Reply Fulfilled',
  Tip: 'Tip',
  Guaranteed_Reply: 'Guaranteed Reply',
  unverifiedNewUserTag: 'New-user-registration-unverified',
  FIELD: 'Field',
  DISABLED: 'Disabled',
  SENSITIVE_CONTENT_WARNING:
    '<div class="sensitive-content" > <div class="line1">Your post has been flagged as inappropriate by multiple users, so it has been changed to being considered as sensitive. </div> <div class="line2"> As a creator on TopFan, it’s your responsibility to ensure all content you share aligns with our <a href="' +
    environment.websiteURL +
    'terms-of-service" target="_blank" class="highlight">community guidelines</a>. </div></div>',
  STEP2: 'step2',
  STEP3: 'step3',
  INTERESTS: 'Interests',
  ACTIVE_SUBSCRIBERS: ' Active Subscribers',
  PROCEED: 'Proceed',
  DELEGATION: 'Delegation',
  SWITCH_PROFILE: 'Switch Profile as Delegate',
  STAY_LOGGED_IN: 'Stay logged in on this device',
  PORTFOLIO: 'Portfolio',
  DISCOVER_CREATORS: 'Discover Creators',
  NO_CREATOR_FOUND: 'No Creators found',
  EXTERNAL_NFT: 'ExternalNft',
  DELETE_NFT: 'Delete NFT',
  FORUM_TOPIC: 'forum-topic',
  DELETE_FORUM_TOPIC: 'Delete Chat Room Topic',
  EXTERNAL_MERCH: 'ExternalMerch',
  SHOPIFY_MERCH: 'ShopifyMerchandise',
  SHOPIFY_MERCHANDISE: 'Shopify Merchandise',
  DELETE_EXTERNAL_MERCH: 'Delete External Merchandise Item',
  DELETE_SHOPIFY_MERCH: 'Delete Shopify Merchandise Item',
  EXTERNAL: 'external',
  EXTERNAL_MERCHANDISE: 'External Merchandise',
  WELCOME_MESSAGE: 'Welcome Message',
  WELCOME_VIDEO: 'Welcome',
  BLOCK_USER: 'Block User',
  EDIT: 'Edit',
  RESOURCES: 'Resources',
  RESOURCE_COMMENT: 'resource-comment',
  RESOURCE_REPLY: 'resource-reply',
  MAY_TAKE_DAYS:
    ' It may take 2-5 business days for funds to arrive in your bank account.',
  REPORT_AS_INAPPROPRIATE: 'Report as Inappropriate',
  MONEY_WITHDRAWAN_DESC_2:
    'Verification In Process, To protect your account and funds, the 3rd Party identity verification system needs more time to process your request. Please check your Wallet > Transaction History in 15 minutes to see the updated status of your withdrawal request.',
  WITHDRAWAL_PENDING_HEADING: 'Withdrawal Pending',
  ADD_TO_WALLET: 'Added to Wallet',
  FREE_TRIAL: 'FREE TRIAL',
  SUBSCRIBED: 'Subscribed',
  CURRENTLY_SUBSCRIBED: 'CURRENTLY SUBSCRIBED',
  SELECT: 'Select',
  START: 'START',
  DAY: 'Day',
  DAYS: 'Days',
  MONEY_WITHDRAWAN_DESC_VERIFF:
    'Verification In Process, To protect your account and funds, the 3rd Party identity verification system needs more time to process your request.',
  VERIFF_PENDING_HEADING: 'Veriff Verification Pending',
  ADDRESS_DROPDOWN_CLOSED: 'ADDRESS_DROPDOWN_CLOSED',
  ADDRESS_DROPDOWN_OPENED: 'ADDRESS_DROPDOWN_OPENED',
  RESTRICTION_CONTENT_DETECTED: 'Restricted Content Detected',
  RESTRICTION_MODAL_DESCRIPTION: `Your content could not be posted at this time, as our automatic recognition system has determined it may violate TopFan Acceptable Content Policy. <br> <br> If you feel this was a mistake, please contact <a href="${environment.websiteURL}/help-faq" target="_blank" class="highlight">TopFan&nbspCustomer&nbspSupport</a> and provide us with details so we can improve the recognition system. <br><br> We greatly appreciate your help in making TopFan an enjoyable and safe platform for all Creators and Fans.`,
  TESTING_VIDEO: 'Testing Video',
  CAPTURE: 'Capture',
  CAMERA_NOT_WORKING:
    'Unable to open the camera as it is either in use by another app or not starting properly.',
  NO_FILE_SELECTED: 'No file selected.',
  INVALID_FILE_TYPE: 'Invalid file type.',
  FAILED_READ_FILE: 'Failed to read file.',
  UPLOAD_FAILED: 'Upload failed.',
  FAILED_LOAD_IMAGE: 'Failed to load image.',
  STREAM_PREVIEW_IMAGE: 'Livestream Preview Image',
  TIP_RECEIVED_1: 'TIP RECEIVED',
  NEW_FOLLOWER: 'NEW FOLLOWER',
  NEW_FOLLOWER_ON_TOPFANS: 'NEW FOLLOWER ON TOPFANS.COM',
  NEW_SUBSCRIBER: 'NEW SUBSCRIBER',
  SHARE: 'Share',
  SEND_TIP: 'Send Tip',
  subscribe: 'subscribe',
  chat: 'chat',
  current_viewers: 'current_viewers',
  LIKE_UPP: 'LIKE',
  DISLIKE: 'DISLIKE',
  likes_count: 'likes_count',
  livestream_updated: 'livestream_updated',
  livestream_ended: 'livestream_ended',
  present_product: 'present_product',
  present_portfolio: 'present_portfolio',
  SHOPPING_CONTENT_TYPE_STORE: 'store',
  SHOPPING_CONTENT_TYPE_PORTFOLIO: 'portfolio',
  SHOPPING_CONTENT_TYPE_EVENT_TICKET: 'event_ticket',
  session_started: 'session_started',
  SEND_EMOJI: 'SEND_EMOJI',
  INVALID_TIMESTAMP: 'Invalid timestamp',
  livestream_purchase: 'livestream_purchase',
  LIVESTREAM_PURCHASE_DOWNLOADABLE: 'DOWNLOADABLE PURCHASED',
  LIVESTREAM_PURCHASE_COURSE: 'COURSE PURCHASED',
  LIVESTREAM_PURCHASE_EXPERIENCE: 'EXPERIENCE PURCHASED',
  LIVESTREAM_PURCHASE_MERCHANDISE: 'MERCHANDISE PURCHASED',
  LIVESTREAM_PURCHASE: 'LIVESTREAM PURCHASED',
  LINK_IN_BIO: 'Link In Bio',
  CAPTURING: 'Capturing...',
  NEW_BRANDS: 'new-brands',
  REQUEST_TO_FOLLOW: 'Request To Follow',
  AVAILABLE_ON: 'Available On',
  TOPIC_TAGS: 'Topic Tags',
  OUTBOUND_EMAILS: 'Outbound Emails',
  TOPIC_TAGS_DESCRIPTION: 'These optional tags allow you to organize your Post content by a topic, so your fans can filter your Post Feed by a respective topic you define. This feature is typically used by creators with multiple lines of business or subject matters that are diverse and require additional levels of organization. Note: For Topic Tags to be enabled, you must have at least two active Topic Tags.',
  ADD_NEW_TOPIC_TAG: 'ADD NEW TOPIC TAG',
  TITLE: 'TITLE',
  DESCRIPTION: 'DESCRIPTION',
  ACTION: 'ACTION',
  NO_TOPIC_TAGS_FOUND: 'Add your first Topic Tag. You must add at least two tags to activate this feature.',
  DELETE_TOPIC_TAG_MSG: 'Are you sure you want to delete {{title}} topic tag?',
  DELETE_TOPIC_TAG: 'Delete Topic Tag',
  CREATE_TOPIC_TAG: 'CREATE TOPIC TAG',
  UPDATE_TOPIC_TAG: 'UPDATE TOPIC TAG',
  ADD_NEW_TOPIC_TAG_TITLE: 'Add New Topic Tag',
  EDIT_TOPIC_TAG_TITLE: 'Edit Topic Tag',
  VIDEO_SM: 'video',
  MKV: 'mkv',
  DOLLAR_SYMBOL: '$',
  PAYMENT_DETAILS_HINT: 'Your credit card will be charged in US Dollars, so the conversion rate might vary slightly.',
  PAY_GAP: 'PAY ',
  TOTAL_AMOUNT_DUE: 'Total Amount Due: ',
  USD_DEFAULT: 'United States Dollars (USD) $',
  Unlock: 'Unlock',
  USD: 'USD',
  CALENDAR_LINK: 'Calendar Link',
  TIMEZONE_LOCATION_HINT: 'is located in this Time Zone',
  PRIVACY_PASSWORD_INTEGRATION: 'Privacy, Password & Integrations',
  UPDATE: 'Update',
  CREATE_LESSON: 'Create Lesson',
  UPDATE_LESSON: 'Update Lesson',
  SAVE_COURSE: 'Save Course',
  UPDATE_COURSE: 'Update Course',
  GROUPS: 'Groups',
  DISCONNECT_SHOPIFY_STORE: 'Disconnect Shopify Store',
  SHOPIFY_STORE_URL_COPIED: 'Shopify store URL copied to clipboard',
  CONNECTED_SHOPIFY_STORE: 'Connected Shopify Store: ',
};

export const validationMessage = {
  imageMax5: 'You cannot upload image size more than 5 MB.',
  widthGreater: 'Width of image should be greater than ',
  pixelGreater: 'pixels and height of image should be greater than ',
  required: '<field> is required',
  invalidDate: 'Invalid Date',
  invalidTime: 'Invalid Time',
  ONLY_FILES_ALLOWED: 'You can upload only files',
  FILE_SIZE_LIMIT: 'File size cannot be more than [fileSize] MB.',
  UPLOADED_FILE: 'Uploaded file',
  maxlength: 'Maximum 1000 characters are allowed',
  ACCEPTED_VIDEO_FORMATS: '.webm,.mp4,.mov,.MOV',
  MAX_VIDEO_SIZE_ALLLOWED_MSG: 'Max allowed size is 500MB',
  MAX_AUDIO_SIZE_ALLLOWED_MSG: 'Max allowed size is 200MB',
  ALL_STANDARD_SPECIAL_CHARS: 'All standard special characters are allowed',
  IMAGE_DIMENSION_MUST_BE: 'Image dimensions must be',
  CURRENT_DIMENSIONS: 'Current dimensions',
  PIXELS: 'pixels'
};

export const StatusCodes = {
  BAD_REQUEST: 400,
  SUCCESS: 200
};

export const formMessages = {
  eventDate: 'Event Date',
  event: 'Event',
  edit: 'Edit',
  add: 'Add ',
  selectEventDate: 'Select Event Date',
  eventDateIsRequired: 'Event Date is required',
  startTime: 'Start Time',
  selectTime: 'Select Time',
  timeZone: 'Time Zone',
  select: 'Select',
  venueName: 'Venue Name',
  country: 'Country',
  stateProvinece: 'State / Province',
  city: 'City ',
  streetAddress: 'Street Address ',
  moreInfo: 'More Info',
  ticketUrl: 'Ticket URL ',
  ctaButtonText: 'CTA Button Text',
  additionalTicketUrl: 'Additional Ticket URL',
  selectStateProvince: 'Select State/province',
  tickets: 'Tickets',
  vip: 'VIP',
  offer: 'Offer',
  addNew: 'Add New',
  NO_VIP_CODE: 'No VIP Code',
  downloadable: 'Downloadables',
  enableShopifyProduct: 'Enable Shopify Product',
  disableShopifyProduct: 'Disable Shopify Product',
  productVisibleToFan: 'This product will be visible to fans.',
  productNotVisibleToFan: 'This product will not be visible to fans.',
  reSyncMerchFromShopify: 'To change prices, descriptions, images or variant information, please login to Shopify, edit there and press "Re-Sync Merch from Shopify" button on the previous screen.'
};

export const defaultCountry = 'United States';
export const defaultTimezone = 'Pacific/Midway';

export const datePickerValidation = {
  today: 'today'
};

export const BANNER_IMAGE = 'BANNER_IMAGE';

const PROFILE_IMAGE = 'PROFILE_IMAGE';
export const getCropmeOptions = (
  type: typeof BANNER_IMAGE | typeof PROFILE_IMAGE,
  isMobileDevice: boolean
) => {
  return {
    container: {
      width: '100%',
      height: Application.FOUR_HUNDRED
    },
    viewport: {
      width:
        type === BANNER_IMAGE
          ? isMobileDevice
            ? Application.TWO_HUNDRED_SEVENTY_FIVE
            : Application.BANNER_WIDTH
          : Application.THREE_HUNDRED,
      height:
        type === BANNER_IMAGE
          ? isMobileDevice
            ? Application.ONE_HUNDRED_TEN
            : Application.BANNER_HEIGHT
          : Application.THREE_HUNDRED,
      type: 'square',
      border: {
        width: Application.TWO,
        enable: true,
        color: '#fff'
      }
    },
    zoom: {
      enable: true,
      mouseWheel: true,
      slider: true,
      min: '0.1',
      max: '3'
    },
    rotation: {
      slider: false,
      enable: false,
      position: 'center'
    },
    quality: 1,
    imageQuality: 1,
    transformOrigin: 'viewport',
    imgHolder: null,
    imgHolderCallback: null
  };
};
export const offerLockOptions = {
  FREE: 'Free',
  SUBSCRIPTION: 'Subscription',
  INDIVIDUAL_PURCHASE: 'Individual Purchase',
  LOCK_WITH_NFT: 'Lock with NFT'
};

export const keyBoardKeyCodes = {
  ENTER: 13
};

export const vipOfferFieldsKey = {
  UNIQUE_CODES: 'unique_codes',
  LOCK_NFT: 'lock_nft',
  ISSUES_CODES: 'issued_codes',
  SUBSCRIPTION: 'subscription',
  INDIVIDUAL_PURCHASE: 'individual_purchase',
  LOYALTY_POINTS_LOCK: 'loyalty_points_lock',
  FREE: 'free',
  GENERAL_CODE: 'general_code'
};
// refund-status.constants.ts
export const REFUND_STATUS_LABELS: Record<string, string> = {
  raised_to_creator: 'Pending',
  raised_to_admin: 'Escalated to Customer Support',
  accepted_by_creator: 'Accepted',
  rejected_by_creator: 'Declined',
  accepted_by_admin: 'Admin Accepted',
  rejected_by_admin: 'Admin Declined'
};

export const REFUND_STATUS_CLASSES: Record<string, string> = {
  raised_to_creator: 'status-pending',
  raised_to_admin: 'status-requested',
  accepted_by_creator: 'status-accepted',
  rejected_by_creator: 'status-rejected',
  accepted_by_admin: 'status-accepted',
  rejected_by_admin: 'status-rejected'
};

export const DEFAULT_TEXT_AREA_CHARS_LIMIT = 1000;
export const DEFAULT_IMAGE_SIZE_LIMIT = 5000000; //5mb
export const CURRENT_TIME_ALLOWED_GAP = 5;
export const META_MASK_URL = 'https://metamask.io';
export const SUBSCRIPTION_TYPE = {
  INDIVIDUAL: 'individual',
  SUBSCRIPTION: 'subscription'
};
export const PAYMENT_FOR_TYPE = {
  MESSAGES_TEXT: 'messages',
  PAY_PER_MESSAGE: 'payPerMessage',
  PAY_PER_MESSAGE_AND_TIP: 'payPerMessageAndTip',
  VIP_OFFER: 'vip-offer',
  STORE_CONTENT: 'store-content',
  SUBSCRIPTION_FROM_MESSAGE: 'subscriptionFromMessage',
  EXPERIENCE: 'Experience',
  COURSE: 'Course',
  MERCHANDISE: 'Merchandise',
  DOWNLOADABLES: 'Downloadables',
  MESSAGES: 'segment-user-message',
  POST: 'post',
  FEATURE: 'feature',
  MESSAGE_INDIVIDUAL: 'message-individual',
  PROFILE: 'profile',
  RENEW_SUBSCRIPTION: 'renewSubscription',
  NFT: 'nft',
  NEWSLETTER: 'newsletter',
  DISCOUNT_NOTE: 'Note: Discount is applied to the initial purchase amount.',
  DISCOUNT_NOTE_NON_RENEWBALE:
    'Note: Discount is applied to the initial purchase amount, and not renewals.',
  LIVE_STREAM: 'livestream',
  LIVE_STREAM_TIP: 'liveStreamTip',
  LIVE_STREAM_PURCHASE: 'liveStreamPurchase',
  CUSTOMIZE_EXPERIENCE: 'customizeExperience',
  CUSTOMER_INFORMATION: 'customerInformation',
  SCHEDULE_EXPERIENCE: 'scheduleExperience',
  SHIPPING_OPTION: 'shippingOptions',
  FUNDRAISER: 'fundraiser',
  MUSIC_PORTFOLIO: 'musicPortfolio',
  LOYALTY_POINTS: 'loyalty-points',
  EVENT_TICKET: 'eventTicket',
  TICKET_CUSTOMER_INFORMATION: 'ticketCustomerInformation',
  TICKET_EVENT_PREVIEW: 'ticketEventPreview',
};

export const TIP_PAYMENT_INTENT = {
  callTypes: [Fields.tip, PAYMENT_FOR_TYPE.LIVE_STREAM_TIP] as string[],
  orderState: {
    loading: 'loading',
    ready: 'ready',
    error: 'error'
  }
} as const;

export const DM_UNLOCK_PAYMENT_INTENT = {
  callTypes: [PAYMENT_FOR_TYPE.MESSAGE_INDIVIDUAL] as string[],
  orderState: {
    loading: 'loading',
    ready: 'ready',
    error: 'error'
  },
  unlockType: 'individual'
} as const;

export const PAYMENT_REDIRECTS = {
  otherProfile: 'otherProfile',
  profile: 'profile',
  post: 'post',
  posts: 'posts',
  WALLET_LOYALTY_POINTS: 'wallet/loyalty-points',
  LOYALTY_POINTS_PURCHASE_RETURN: 'loyaltyPointsPurchaseReturn',
  CHAT_ROOM: 'chat_room'
};

export const storeContentKeys = {
  [PAYMENT_FOR_TYPE.EXPERIENCE]: 'experience_id',
  [PAYMENT_FOR_TYPE.MERCHANDISE]: 'merchandise_id',
  [PAYMENT_FOR_TYPE.COURSE]: 'course_id',
  [PAYMENT_FOR_TYPE.DOWNLOADABLES]: 'downloadables_id',
  [PAYMENT_FOR_TYPE.NEWSLETTER]: 'newsletter_id'
};
export const CSV_COLUMN_KEY = {
  OPTIONS: 'OPTIONS',
  CODES: 'CODES'
};

export const MINIMUM_OFFER_CODE_ALERT_LIMIT = 50;
export const DEFAULT_CURRENCY = 'usd';
export const PAYMENT_METHOD = {
  WALLET: 'wallet',
  CARD: 'card'
};

export const SOURCE_TYPE = {
  FUNDRAISER: 'FUNDRAISER'
};

export const suspendAccount = {
  suspensionMessage: 'Your account has been suspended due to'
};

export const BreakPoint = {
  XSmallScreen: 480,
  SmallScreen: 576,
  LargeScreen: 992
};

export const POST_TYPE_KEY = {
  REEL: 'reel',
  VIDEO: 'video',
  ARTICLE: 'article',
  LINK: 'link'
};
export const StoreItemType = {
  EXPERIENCE: 'Experience',
  COURSE: 'Course',
  MERCHANDISE: 'Merchandise',
  DOWNLOADABLE: 'Downloadable',
  SHOPIFY: 'Shopify',
  NFTS: 'Nfts',
  NEWSLETTER: 'Newsletter',
  PORTFOLIO_SHARING: 'PORTFOLIO_SHARING'
};

export const EXPERIENCE_TYPE = {
  PERSONALIZED_VIDEO: 'personalized_video',
  ONE_TO_ONE_CALL: 'one_to_one_call',
  IN_PERSON_MEETING: 'in_person_meeting',
  SOCIAL_MEDIA: 'socialmedia_follow_comment',
  CUSTOM_EXPERIENCE: 'custom_experience'
};

export const WELCOME_MESSAGE = 'WELCOME_MESSAGE';

export const SIDE_BAR_MODULE = {
  MONETIZE: 'monetize',
  RESOURCES: 'resources'
};
export const ThresholdScrollableLimit = {
  SCROLLABLE_LIMIT: 2
};

export const DEFAULT_DATE_TIME_FORMAT = 'MMM d, y h:mm a';
export const DEFAULT_DATE_FORMAT = 'MMM d, y';
export const DEFAULT_DATE_FORMAT_D = 'MMM D, y';
export const DEFAULT_DATE_FORMAT_Y = 'MMM D, YYYY';

export const MONETIZE_SECTION_HEADERS = {
  MONETIZE: 'Monetize',
  SUBSCRIPTIONS: 'Subscriptions',
  EXPERIENCES: 'Experiences',
  COURSES: 'Courses',
  MERCHANDISE: 'Merchandise',
  DOWNLOADABLES: 'Downloadables',
  NFTS: 'NFTS',
  VIP_OFFERS: 'VIP OFFERS',
  REFERRALS: 'Referrals',
  EVENTS_TICKETING: 'Event Ticketing',
  NEWSLETTERS: 'Newsletters',
  PORTFOLIO: 'PORTFOLIOS',
  ADVERTISEMENTS: 'ADVERTISEMENTS',
  AD_PREFERENCES: 'AD PREFERENCES',
  EARNINGS: 'EARNINGS',
  EVENTS_AND_TICKETING: 'Events & Ticketing',
  MONETIZE_HINT:
    'To set the order of your Store items or feature items on your profile, click the Store button on your Profile and use the controls on that screen.'
};

export const AD_PREFERENCES_CONSTANTS = {
  SEARCH_BRANDS: 'Search Brands',
  ADVERTISEMENT_PREFERENCES: 'Advertisement Preferences',
  ENABLE_ADS: 'Enable Ads',
  DISABLE_ADS: 'Disable Ads',
  NEW_BRANDS_TO_APPROVE: 'New Brands to Review',
  ALL_CATEGORIES: 'All Categories',
  ALL_CATEGORY_ID: 'all',
  FOOD: 'Food',
  BEVERAGES: 'Beverages',
  PERSONAL_CARE_AND_HYGIENE: 'Personal Care and Hygiene',
  TRAVEL_AND_LEISURE: 'Travel & Leisure',
  HEALTH_AND_WELLNESS: 'Health and Wellness',
  BABY_AND_CHILDCARE: 'Baby and Childcare',
  PET_CARE: 'Pet Care',
  AUTOMOBILE: 'Automobile',
  SELECT_ALL: 'Select All',
  REJECT_ALL: 'DECLINE ALL',
  APPROVE_ALL: 'APPROVE ALL',
  REJECT_SELECTED: 'DECLINE SELECTED',
  APPROVE_SELECTED: 'APPROVE SELECTED',
  CANCEL: 'Cancel',
  SAVE: 'SAVE',
  REJECT: 'Reject',
  APPROVE: 'Approve',
  APPROVE_ACTION: 'approve',
  REJECT_ACTION: 'reject',
  BEVERAGE: 'Beverage',
  PET_CARE_CATEGORY: 'Pet Care',
  PERSONAL_CARE_CATEGORY: 'Personal Care and Hygiene',
  SHARE_TEXT:
    'If you are already working with a brand who wants to run ads on your TopFan.com profile page and white-label site, please direct them to  [advertisement_url], where they can setup their ad campaign.<br><br>When they use your referral code, you will receive a 15% revenue share bonus, and earn 85% of revenue from the ads that run on your profile and white-label site.',
  SHARE_TITLE: 'Already working with a Brand?',
  SHARE: 'SHARE',
  COPY: 'COPY',
  WHY_ENABLE_ADS_TITLE: 'Why Enable Ads on your Account?',
  WHY_ENABLE_ADS_DESCRIPTION: 'Invite well-known third-party brands to advertise with you on your TopFan.com page and white-label site. When your fans see these ads, you will receive payment (70-85% of the advertising fee) into your wallet. You are always in control of which brands you want to associate with and earn from, by making your selections in the Advertisement Preferences section.',
  WHY_ENABLE_ADS_DESCRIPTION_MODAL: `Work with well-known third-party brands to advertise with you on your TopFan.com page and white-label site. When your fans see these ads (i.e., an impression), you will receive payment (70% of the advertising fee) into your wallet. You are always in control of which brands you want to associate with and earn from, by making your selections in the Advertisement Preferences section.
  <br><br>
  You can also invite brands you already work with to advertise with on your profile and site, by sending them to <a href="${environment.original_web_url}advertise">${environment.original_web_url}advertise</a>. You will receive a 15% bonus (85% of the advertising fee) for brands you refer. Click Enable Ads to get your unique referral code. 
  `,
  EARNINGS: 'EARNINGS',
  DATE: 'DATE',
  VIEW: 'View',
  SELECT_MONTH: 'Select Month',
  SELECT_YEAR: 'Select Year',
  LOADING_EARNINGS: 'Loading earnings...',
  NO_EARNINGS_DATA: 'No earnings data available',
  NO_EARNINGS_DATA_FOR: 'No earnings data available for',
  MONTH: 'month',
  YEAR: 'year',
  MIN_YEAR: 2024,
  ENABLE_ALL_NEW_BRANDS:
    'Enable All New Brands in All Categories Automatically',
  SAVE_CHANGES: 'Save Changes',
  ARE_YOU_SURE_YOU_WANT_TO_SAVE_CHANGES:
    'Are you sure you want to save changes?',
  LOADING_PREFERENCES: 'Loading preferences...',
  LOADING_CATEGORIES: 'Loading categories...',
  NO_CATEGORIES_AVAILABLE: 'No categories available',
  LOADING_BRANDS: 'Loading brands',
  NO_BRAND_AVAILABLE_IN_CATEGORY: 'No Brands Available in this category',
  LOADING_MORE_BRANDS: 'Loading more brands...',
  EARNINGS_ON: 'Earnings on',
  NO_BRAND_DATA_AVAILABLE_FOR_DATE: 'No brands data available for this date.',
  ShouldDisable: 'Disable New Brands',
  ShouldEnable: 'Automatically Enable Future Brands',
  ShouldDisableDescription: `If you disable, any new brand that joins TopFan, will not be automatically enabled for your profile and white-label site, and you will miss these new revenue opportunities. However, you can still manually enable new brands.`,
  ShouldEnableDescription: `If this option is enabled, any newly added Brand's advertisements may be shown your profile and white-label site.`,
  disbleFutureBrands: 'DISABLE NEW BRANDS',
  enableFutureBrands: 'ENABLE NEW BRANDS',
  enableAds: 'enableAds',
  selectAll: 'selectAll',
  EARNINGS_SM: 'earnings',
  PREFERENCES_SM: 'preferences',
  NO_NEW_BRANDS_TO_APPROVE: 'No New Brands to Approve'
};

export const AD_EARNINGS_MONTHS = [
  { label: 'January', value: '1' },
  { label: 'February', value: '2' },
  { label: 'March', value: '3' },
  { label: 'April', value: '4' },
  { label: 'May', value: '5' },
  { label: 'June', value: '6' },
  { label: 'July', value: '7' },
  { label: 'August', value: '8' },
  { label: 'September', value: '9' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' }
];

export const BRAND_TABLE_HEADERS = [
  {
    key: 'brand_name',
    label: 'BRAND NAME',
    width: 'w-60 w-m-100',
    type: TableHeaderTypes.IMAGE_WITH_TITLE_DESC,
    keyGroup: {
      src: 'brand_logo',
      title: 'brand_name'
    }
  },
  {
    key: 'amount',
    label: 'EARNINGS',
    width: 'w-40 w-m-100',
    type: TableHeaderTypes.CURRENCY
  }
];

export const DEFAULT_SCROLL_LIMIT_THRESHOLD = 80;
export const subscriptionExpire = {
  NEED_TO_SUBSCRIBE_TO_COMMENT_ON_POST:
    'You need to be a subscriber to comment on this post',
  NEED_TO_SUBSCRIBE_TO_ACCESS_CHATROOM:
    'You need to be a subscriber to access chatroom',
  TO_COMMENT_YOU_NEED_TO_SUBSCRIBER:
    'To post your comment you need to be a subscriber',
  STATIC: 'static',
  CHATROOM: 'chatroom',
  SUBSCRIPTION_MESSAGE:
    "To comment on [username]'s post, you need to become a subscriber"
};
export const SELECT_INTERESTS = 'Select Interests';
export const LOAD_MORE = 'LOAD MORE';
export const CREATOR_PROFILE_INFO = {
  REVIEW_YOUR_INFORMATION: 'APPLY FOR A NEW CREATOR ACCOUNT',
  STEP_1_OF_3: 'STEP 1 OF 3',
  CANCEL: 'Cancel',
  UPLOAD: 'Upload',
  NEXT: 'Next',
  CREATOR_REQUEST_PENDING_MSG:
    'Your application to Become a Creator is being reviewed.',
  CREATOR_REQUEST_FAILURE_HEADING:
    'Your application to become a creator was not approved.',
  YOUTUBE_URL: 'www.youtube.com/@',
  TIKTOK_URL: 'www.tiktok.com/@',
  INSTAGRAM_URL: 'www.instagram.com/',
  TWITTER_URL: 'www.x.com/',
  LINKEDIN_URL: 'www.linkedin.com/in/',
  SNAPCHAT_URL: 'www.snapchat.com/add/',
  WEBSITE_URL_PREFIX: 'https://',
  FACEBOOK_URL: 'www.facebook.com/',
  SPOTIFY_URL: 'open.spotify.com/artist/',
  VERIFICATION_FAILED_MSG:
    'Verification Failed. Please Resubmit Your Become a Creator Application.',
  REASON: 'Reason: ',
  RESUBMIT: 'RESUBMIT'
};
export const VERIFY_IDENTITY = {
  IDENTITY_VERIFICATION: 'IDENTITY VERIFICATION',
  STEP_3_OF_3: 'STEP 3 OF 3',
  DESCRIPTION:
    'To protect your identity on TopFan from imposters, we utilize a well respected 3rd Party identity verification service called Veriff. They will require you to upload a Government ID and go through a selfie Verification process. There is no cost and your data is 100% secure. This step will only take 2-5 minutes.',
  THANKYOU_MSG:
    'Thank you for helping us make TopFan the safest platform available for creators.',
  VERIFY_MY_IDENTITY: 'Verify My Identity'
};
export const CREATOR_ACCOUNT_UPGRADED = {
  MSG: 'Your Application to Become a Creator has been Approved!',
  PROCEED: 'PROCEED TO 2FA SIGN IN',
  NOTE: 'To keep your creator account secure, you will now need to Sign In to TopFan using Two Factor Authentication (2FA)'
};
export const VERIFICATION_STATUS = {
  APPROVED: 'approved',
  PENDING: 'pending'
};
export const MOBILE_BREAKPOINT = 995;
export const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: ' ',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  INPUT: 'INPUT',
  TEXTAREA: 'TEXTAREA'
};

export const TRANSLATION_MODULES = {
  POST: 'post',
  CHATROOM: 'chatroom',
  CHATROOM_COMMENT: 'chatroomComment',
  POST_COMMENT: 'comment',
  STORE: 'store',
  LIVESTREAM: 'livestream'
};
export const FEED_PREVIEW_IMAGE_ORIENTATION = {
  PORTRAIT: 'portrait-banner',
  LANDSCAPE: 'landscape-banner'
};
export const FEED_PREVIEW_IMAGE_TYPE = {
  TYPE_1: 'type1',
  TYPE_2: 'type2'
};
export const DEFAULT_LOCALE_FOR_NUMBER_FORMAT = 'en-US';
export const ROUTE_UNIQUE_KEYS = {
  STORE_VIP_OFFERS: 'STORE_VIP_OFFERS',
  STORE_EVENT_CALENDAR: 'STORE_EVENT_CALENDAR',
  ALL_MERCHANDISE: 'ALL_MERCHANDISE'
};
export const FAN_MINIMUM_AGE = 16;
export const CREATOR_MINIMUM_AGE = 18;

export const NEW_POST_DESCRIPTION = {
  LOCK: 'Lock',
  COLLABORATE: 'Collaborate'
};

export const postTypePlaceholderMap = {
  All: 'All Content',
  IMAGE: 'Images',
  TEXT: 'Text',
  VIDEO: 'Videos',
  POLL: 'Polls',
  LINK: 'Links',
  AUDIO: 'Audio',
  REEL: 'Reels',
  GIVEAWAY: 'Giveaways',
  ARTICLE: 'Articles',
  DOWNLOADABLE: 'Downloadables'
};
export const RESOURCES_SECTION_HEADERS = {
  RESOURCES: 'Creator Resources',
  ANNOUNCEMENTS: 'Announcements',
  TIP_TUTORIALS: 'Tips & Tutorials',
  SERVICE_PROVIDERS: 'Service Providers',
  CREATOR_SUPPORT: 'Creator Support',
  GUIDES: 'Guides'
};
export const LIKE_SHARE_BAR_LABELS = {
  LIKE: 'Like',
  COMMENT: 'Comment',
  REPLY: 'Reply',
  SHARE: 'Share',
  SEND_TIP: 'Send Tip'
};

export const ERROR_MSG = {
  CODE_COPIED: 'Code copied to clipboard',
  CAMERA_ACCESS_DENIED: 'Camera access denied or not available.',
  NO_CAMERA_SELECTED: 'No camera selected',
  PLEASE_ADD_NFT_OPTION: '`Please add at least one NFT option`'
};

export const SUCCESS_MSG = {
  LIVESTREAM_ENDED: 'The livestream has ended. Thank you for watching!'
};
export const WEEK_LABELS = {
  THIS_WEEK: 'this-week',
  LAST_WEEK: 'last-week',
  THIS_MONTH: 'this-month',
  LAST_MONTH: 'last-month',
  TODAY: 'today',
  CUSTOM_DATES: 'custom-range',
  ALL_TIME: 'all-time'
};

export const API_RESPONSE_TYPE = {
  TEXT: 'text',
  JSON: 'json'
};

export const HISTORY_NOT_TO_INCLUDE = [
  '/auth/signup',
  '/content',
  '/auth/login',
  '/auth/verify-by-otp',
  '/content/setup-profile',
  '/creators',
  'auth/forgot-password',
  'auth/reset-password',
  '/auth/creators-signup',
  '/edit-preference/become-a-creator/confirm-creator?creators=true',
  'edit-preference/become-a-creator/verify-identity?creators=true',
  '/edit-preference'
];

export const HEADER_LABELS = {
  SITE_EXPERIENCE: 'Site Experience',
  MY_SITE: 'My Site',
  MORE_OPTIONS: 'More options'
};

export const LEGAL_LINK_LABELS = {
  TERMS: 'Terms',
  PRIVACY_POLICY: 'Privacy Policy',
  SEPARATOR: '&'
} as const;

/** Default TopFan header logos when `whiteLabelConfig.logo_url` is absent */
export const TOPFAN_HEADER_DEFAULT_LOGO_URLS = {
  MARKETING_HOME_FALLBACK: 'https://cdn-www.topfans.com/TopFans/1768394224_topfan_logo_dark.png',
  PRO_PAGE: 'https://cdn-www.topfans.com/TopFans/1783507099721.png',
  DEFAULT: 'https://cdn-www.topfans.com/TopFans/1768209868_logo-white-table.webp'
} as const;

export const PORTFOLIO_CONSTS = {
  UNLOCK_MODAL_HEADER: 'Unlock Content',
  UNLOCK_MODAL_MESSAGE: 'Unlock access through options below',
  MUSIC: 'Music',
  PORTFOLIO_ITEM: 'Portfolio Item',
  DELETE_SONG_MSG: 'Are you sure you want to delete the song, {{title}}?',
  DELETE_SONG: 'Delete Song',
  SONG: 'song',
  DELETE_PODCAST_MSG: 'Are you sure you want to delete the podcast, {{title}}?',
  DELETE_PODCAST: 'Delete Podcast',
  ALBUM_SM: 'album',
  SERIES_SM: 'series',
  TYPE: {
    MUSIC: 'MUSIC',
    VIDEO: 'VIDEO',
    PODCAST: 'PODCAST',
    CUSTOM: 'CUSTOM',
  },
  ACTION: {
    LISTEN_NOW: 'Listen Now',
    LISTEN: 'Listen',
    WATCH: 'Watch',
    STREAM: 'Stream',
    PREVIEW: 'Preview',
    PLAY: 'Play',
  },
  DELETE_CHILD_DATA_TITLE: {
    MUSIC: 'Delete Song',
    VIDEO: 'Delete Video',
    PODCAST: 'Delete Podcast',
    CUSTOM: 'Delete Item',
  },
  DELETE_CHILD_DATA_MESSAGE: {
    MUSIC: 'Are you sure you want to delete the song, {{title}}?',
    VIDEO: 'Are you sure you want to delete the video, {{title}}?',
    PODCAST: 'Are you sure you want to delete the podcast, {{title}}?',
    CUSTOM: 'Are you sure you want to delete the item, {{title}}?',
  }
};

export const SORTING_ORDERS = {
  ASC: 'asc',
  DESC: 'desc'
} as const;

export const CONVERSION_MULTIPLIERS = {
  SECONDS_TO_MILLISECONDS: 1000,
  MINUTES_TO_SECONDS: 60,
  MINUTES_TO_MILLISECONDS: 60000,
  HOURS_TO_MILLISECONDS: 3600000
};

export const PROFILE_CONST = {
  THEMES: [
    { label: 'Dark', value: 'theme-dark' },
    { label: 'Default', value: 'theme-default' },
    { label: 'Light', value: 'theme-light' }
  ],
  EDIT_PREFERENCES: 'Edit Preferences',
  PROFILE: 'Profile',
  INTERESTS: 'Interests',
  SIGN_OUT: 'Sign Out',
  EDIT_PERSONAL_INFO: 'Edit Personal Info'
}

export const ADDRESS_DISPLAY_CONST = {
  city: 'city',
  state: 'state',
  zip: 'zip',
  country: 'country',
  postal_code: 'postal_code',
  postalCode: 'postalCode',
  zip_code: 'zip_code',
  zipCode: 'zipCode',
  venue_name: 'venue_name',
  venueName: 'venueName',
  street_address: 'street_address',
  streetAddress: 'streetAddress',
  establishment: 'establishment',
  point_of_interest: 'point_of_interest',
  premise: 'premise'
};

export const LOCATION_IFRAME_CONST = {
  COLLAPSED_HEIGHT: '55px',
  COLLAPSED_RADIUS: '0px',
  EXPANDED_RADIUS: '20px',
  MAX_DROPDOWN_HEIGHT: 200,
  MAX_DROPDOWN_HEIGHT_PX: '200px',
  INPUT_ROW_HEIGHT: 65,
  REVEAL_FALLBACK_MS: 2500
} as const;

export const UPLOAD_IMAGE_ENDPOINT = 'upload-image';